import React, { useMemo } from 'react'
import { usePolicies } from 'src/components/async/policy'
import { NONE_ID, NONE_NAME } from 'src/Utils/globalConstants'
import { ListPoliciesRequest } from '@trustero/trustero-api-web/lib/model/policy_pb'
import {
  BoolValue,
  StringValue,
} from 'google-protobuf/google/protobuf/wrappers_pb'
import { useInAudit } from 'src/context/AuditContext'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardPolicyFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { auditId } = useInAudit()
  const request = useMemo(() => {
    const req = new ListPoliciesRequest().setIsDismissed(
      new BoolValue().setValue(false),
    )
    if (auditId) {
      req.setAuditId(new StringValue().setValue(auditId))
    }
    return req
  }, [auditId])
  const { data: policies } = usePolicies(request)
  const noPolicyValue = {
    value: NONE_ID,
    label: NONE_NAME,
  }
  const filterValues = [
    noPolicyValue,
    ...(policies?.getItemsList().map((policy) => ({
      value: policy.getName(),
      label: policy.getName(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_POLICY}
      filterName={FilterName.DASHBOARD_POLICY}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
